import {useMutation} from 'react-query';
import {getGrade} from 'services/grade';

const useGetGradeQuestions = (
  setQuestions: React.Dispatch<React.SetStateAction<IGetGradeQuestions[]>>,
  setIsOpenGradeQuestions: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const {isLoading, mutate: gradeQuestions} = useMutation({
    mutationFn: (payload: string) => {
      return getGrade(payload);
    },
    onSuccess: (_, variables) => {
      setQuestions(_);
      setIsOpenGradeQuestions(true);
    },
  });

  return {gradeQuestions, isLoading};
};

export default useGetGradeQuestions;
